import { Node, SplitNode } from '@/api/dashboard'
import { BlockError, EventActionNodeType } from '../types'
import { FieldGroup, FieldSection, RangeSlider } from '@/ui'
import SettingsHeader from '../SettingsHeader'
import { useContext, useState } from 'react'
import { Input, Textarea, cn } from '@dashboard/ui'
import { useTranslation } from 'react-i18next'
import { getDisabledClasses } from '@/layouts/campaigns/util'
import { CampaignContext, ICampaignContext } from '@/expr/Context'

export const SplitNodeEditor = (props: {
  error?: BlockError | null
  node: SplitNode
  setNode: (node: Node) => void
  onClose: () => void
}) => {
  const context = useContext(CampaignContext) as ICampaignContext
  const { t } = useTranslation()
  const [node, setNode] = useState<SplitNode>({
    ...props.node,
  })

  const onChange = (index: number, value: number) => {
    if (value >= 100 || value <= 0) {
      return
    }
    let newDistribution = [...node.distribution]
    if (index == 0) {
      newDistribution[0].value = value
      newDistribution[1].value = 100
    } else if (index == 1) {
      newDistribution[0].value = 100 - value
      newDistribution[1].value = 100
    }

    setNode({
      ...node,
      distribution: newDistribution,
      model_type: EventActionNodeType.SplitNode,
    })
  }

  const onSaveClick = () => {
    props.setNode(node as Node)
    props.onClose()
  }

  const handleSliderChange = (newValue: number) => {
    onChange(0, newValue as number)
  }

  return (
    <div>
      <SettingsHeader node={node as Node} onSave={onSaveClick} onClose={props.onClose} />
      <div className={cn('p-6', getDisabledClasses(context.readOnly))}>
        <FieldSection label={t('coupon.general')}>
          <div className="ml-2">
            <RangeSlider
              type="range"
              id="volume"
              name="volume"
              onChange={handleSliderChange}
              value={node.distribution[0].value}
              defaultValue={50}
              min={1}
              max={99}
              width={320}
            />
          </div>
          <FieldGroup label={t('campaign.block.SplitNode.left_percent')}>
            <Input
              value={node.distribution[0].value}
              type={'number'}
              onChange={e => {
                let v = parseInt(e.target.value)
                onChange(0, v)
              }}
            />
          </FieldGroup>

          <FieldGroup label={t('campaign.block.SplitNode.right_percent')}>
            <Input
              value={100 - node.distribution[0].value}
              type={'number'}
              onChange={e => {
                let v = parseInt(e.target.value)
                onChange(1, v)
              }}
            />
          </FieldGroup>

          <FieldGroup label={t('campaign.block.SplitNode.description')}>
            <Textarea
              value={node.description}
              onChange={e => {
                setNode({
                  ...node,
                  description: e.target.value,
                  model_type: EventActionNodeType.SplitNode,
                })
              }}
            />
          </FieldGroup>
        </FieldSection>
      </div>
    </div>
  )
}
